import { useState } from "react";
import DashboardHeader from "./DashboardHeader";
import DashboardFooter from "./DashboardFooter";
import NewCaseForm from "./NewCaseForm";
import ExistingPatientSearch from "./ExistingPatientSearch";
import ExcelImportExport from "./ExcelImportExport";
import PatientPreview from "./PatientPreview";

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState("new");
  const [editPatient, setEditPatient] = useState(null);
  const [previewPatient, setPreviewPatient] = useState(null); // 👁️ View mode

  const handleTabChange = (newTab) => {
    if (newTab === activeTab) return;

    const confirmChange = window.confirm(
      "Are you sure you want to switch sections? Unsaved data may be lost."
    );
    if (confirmChange) {
      setActiveTab(newTab);
      setEditPatient(null);
      setPreviewPatient(null);
    }
  };

  const handleViewPatient = (patient) => {
    setPreviewPatient(patient); // Show preview
    setEditPatient(null);       // Clear edit mode
  };

  const handleEditPatient = (patient) => {
    setEditPatient(patient);    // Load for editing
    setPreviewPatient(null);    // Hide preview
    setActiveTab("new");        // Switch to form
  };

  const handleClosePreview = () => {
    setPreviewPatient(null);
  };

  const renderContent = () => {
    if (previewPatient) {
      return (
        <PatientPreview
          patient={previewPatient}
          onEdit={handleEditPatient}
          onClose={handleClosePreview}
        />
      );
    }

    switch (activeTab) {
      case "new":
        return <NewCaseForm editPatient={editPatient} />;
      case "existing":
        return <ExistingPatientSearch onSelect={handleViewPatient} onEdit={handleEditPatient} />;
      case "excel":
        return <ExcelImportExport />;
      default:
        return (
          <div className="text-center text-gray-600 py-10">
            Select a section
          </div>
        );
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <DashboardHeader activeTab={activeTab} onTabChange={handleTabChange} />
      <main className="flex-1 max-w-6xl mx-auto w-full p-6">
        {renderContent()}
      </main>
      <DashboardFooter />
    </div>
  );
}
